import { useRosterFocusStore } from "@/store/rosterFocusStore";

function WeeklyOffTdShiftCodeBtnView({
  day,
  shift,
  prefix = "",
}: {
  day: number;
  shift: { shift_id: string; name: string; color: string } | undefined;
  isEveryFifth?: boolean;
  prefix?: string;
}) {
  const columnKey = `${prefix}day${day}`;
  const isColumnHovered = useRosterFocusStore(
    (s) => s.hoveredColumn === columnKey
  );
  const isColumnSelected = useRosterFocusStore(
    (s) => s.selectedColumn === columnKey
  );
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);
  const setSelectedFocus = useRosterFocusStore((s) => s.setSelectedFocus);

  const highlightBg = isColumnSelected
    ? "rgba(169, 223, 254, 0.4)"
    : isColumnHovered
      ? "rgba(169, 223, 254, 0.3)"
      : undefined;

  return (
    <div
      data-column={columnKey}
      style={highlightBg != null ? { backgroundColor: highlightBg } : undefined}
    >
      <div className="padding_hover_bg_vertical effect_hover_bg_vertical">
        <div className="padding_hover_bg_horizon effect_hover_bg_horizon p-r">
          <div className="d-f jc-c ai-c h-100p">
            <button
              type="button"
              className="rt_shiftCode"
              title={shift?.name ?? "미배정"}
              style={{ backgroundColor: shift?.color ?? "#d6d6de" }}
              onMouseEnter={() => {
                setHoveredFocus({ column: columnKey, nurseId: "" });
              }}
              onMouseLeave={() => {
                clearHoveredFocus();
              }}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedFocus({ column: columnKey, nurseId: "" });
              }}
            >
              {shift?.shift_id ?? "-"}
            </button>
            <div className="errorShift">
              <div className="errorBadge"></div>
              <ul className="errorMessage"></ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeeklyOffTdShiftCodeBtnView;
